import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import MuiInputNumber from '../MuiInputNumber';

/**
 * @typedef {object} FormMuiInputNumberOwnProps
 * @property {string} name
 */

/**
 * @typedef {FormMuiInputNumberOwnProps & React.ComponentProps<typeof MuiInputNumber>} FormMuiInputNumberProps
 */

/**
 * @param {FormMuiInputNumberProps} props
 */
const FormMuiInputNumber = props => {
  const { name, ...otherProps } = props;
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <MuiInputNumber
          error={!!error}
          handleChange={field.onChange}
          value={field.value}
          inputRef={field.ref}
          {...otherProps}
        />
      )}
    />
  );
};

export default FormMuiInputNumber;
